import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import { alpha } from "@material-ui/core/styles";
import Edit from "@material-ui/icons/Edit";
import Avatar from "@material-ui/core/Avatar";
import { useRef, useState } from "react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";

import { Main } from "src/components/commons/Main";
import { VendorServiceForm } from "src/components/vendorServices/Form";
import Table from "src/components/commons/Table/Table";
import StatusChip from "src/components/commons/StatusChip";
import { DashboardEmptyState } from "src/components/icons/all/dashboard/DashboardEmptyState";

const statusMap = { UNREAD: "Unread", READ: "Read", ARCHIVED: "Archived" };

const useStyles = makeStyles((theme) => ({
	avatar: {
		width: 40,
		height: 40,
		background: theme.palette.background.default,
		"& img": {
			objectFit: "contain",
		},
	},
	modal: {
		transform: "translate(-50%, -50%)",
	},
}));

export function VendorMessages() {
	const { state } = useLocation();
	const navigate = useNavigate();
	const paginatedMessages = useLoaderData();
	const classes = useStyles();
	const [openFormModal, setOpenFormModal] = useState(state?.create || false);
	const selectedMessage = useRef(null);

	const columns = [
		{
			header: 'Messages',
			accessor: 'name',
			render: (value, row) => (
				<Box display="flex" alignItems="center">
					<Avatar
						className={classes.avatar}
						variant="rounded"
						alt={row.name}
						src="/images/icons/campaign.svg"
					/>
					<Box ml={2}>
						<Typography variant="body1">{row.name}</Typography>
						<Typography variant="body2" color="textSecondary">
							{row.description}
						</Typography>
					</Box>
				</Box>
			)
		},
		{
			header: 'Status',
			accessor: 'status',
			align: 'center',
			render: (value) => (
				<StatusChip status={statusMap[value]} />
			)
		},
		{
			header: 'Action',
			accessor: 'id',
			align: 'right',
			render: (value, row) => (
				<Box>
					<Button
						startIcon={<Edit />}
						style={{ marginRight: "0.5rem" }}
						color="primary"
						size="small"
						variant="contained"
						onClick={() => {
							selectedMessage.current = row;
							setOpenFormModal(true);
						}}
					>
						View Message
					</Button>
				</Box>
			)
		}
	];

	return (
		<Main>
			<Box display={"flex"} justifyContent="space-between" p={4} px={4} borderBottom={"1px solid rgb(239 232 251)"}>
				<Typography component={"h2"} variant="h6">
					Messages
				</Typography>
			</Box>
			{paginatedMessages.data.length === 0 ? (
				<DashboardEmptyState 
					title="No Messages Found"
					description="Messages will appear here once you receive any communications"
				/>
			) : (
				<Box p={4}>
					<Table
						columns={columns}
						data={paginatedMessages.data}
						loading={false}
						error={false}
						page={0}
						rowsPerPage={10}
						totalCount={paginatedMessages.data.length}
						onPageChange={() => {}}
						onRowsPerPageChange={() => {}}
						getRowId={(row) => row.id}
						className="border-0 shadow-none"
						stickyHeader
					/>
				</Box>
			)}
			<Dialog
				fullWidth={true}
				maxWidth="xs"
				open={openFormModal}
				onClose={() => setOpenFormModal(false)}
				arialabelledby={"form-vs-dialog"}
			>
				<DialogTitle id="form-vs-dialog" pb={0}>
					Message Details
				</DialogTitle>
				<VendorServiceForm vendorService={selectedMessage.current} close={() => setOpenFormModal(false)} />
			</Dialog>
		</Main>
	);
}

export function vendorMessagesLoader() {
	// Temporarily return empty data to test empty state
	return {
		data: [],
		total: 0,
		page: 1,
		limit: 10
	};
} 